/**
 * @fileoverview Safely serializes a JSON-LD entity for inline embedding
 * inside a `<script type="application/ld+json">` tag.
 *
 * `JSON.stringify` alone is not safe to inject via `dangerouslySetInnerHTML`:
 * every JSON-LD builder in `build-json-ld.ts` pulls string fields straight
 * from tenant-controlled data (team `browserTitle`, event names, FAQ copy,
 * ...). If any of those strings contain the literal substring `</script>`, an
 * HTML parser closes the script tag right there and parses the remainder as
 * markup — a stored-XSS vector on a public, unauthenticated page.
 *
 * Escaping every literal `<` character as the six-character JSON unicode
 * escape sequence `\\u003c` closes that hole: `</script>` can no longer
 * appear literally in the output, but the escaped and unescaped forms
 * decode to the exact same character for any JSON parser, so the
 * structured data itself is unchanged.
 */
export function serializeJsonLdScript(entity: object): string {
  return JSON.stringify(entity).replace(/</g, '\\u003c');
}
